import NationIcon from '@/components/bookStatus/NationIcon';
import { NATION_COLOR_LIST } from '@/constants/book';
import { Icon } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  nations: { code: string; name: string | undefined }[];
};

function NationList({ nations }: Props) {
  return (
    <Wrapper>
      {nations.map(({ code, name }, index) => (
        <NationItem key={code} index={index}>
          {name}
          <NationIcon code={code} name={name} index={index} />
        </NationItem>
      ))}
      <NationItem index={4}>
        기타
        <GlobalIcon index={4}>
          <Icon.Globe size={14} fillColor='#ffffff' />
        </GlobalIcon>
      </NationItem>
    </Wrapper>
  );
}

const Wrapper = styled.ul`
  display: flex;
  gap: 15px;
  margin-top: 6px;
`;

const NationItem = styled.li<{ index: number }>`
  display: flex;
  align-items: center;
  position: relative;
  gap: 4px;
  padding-left: 10px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: ${({ index }) => NATION_COLOR_LIST[index] || '#AF54FF'};

  &::before {
    content: '';
    width: 2px;
    height: 12px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    background-color: ${({ index }) => NATION_COLOR_LIST[index] || '#AF54FF'};
  }
`;

const GlobalIcon = styled.div<{ index: number }>`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: ${({ index }) => NATION_COLOR_LIST[index] || '#AF54FF'};
`;

export default NationList;
